import styled from "styled-components";

export const ContainerPassword = styled.div`
  position: relative;
`;

export const IconEye = styled.div`
  padding: 0.25rem;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  cursor: pointer;
`;
